export default {
  UNKNOWN: 'unknown', // in case we are loading and unsure of the context, this context should be used
  FRONTPAGE: 'frontpage',
  CONTENT: 'content',
  DIGITAL_MAG: 'digital_mag',
}
